import { hash } from '@ember/helper';
import StatusOption from 'volta/components/filters/status-option';
import categoryColor from 'volta/helpers/category-color';
import orElse from 'volta/helpers/or-else';

import type { TOC } from '@ember/component/template-only';

export interface FiltersBufferZoneOptionSignature {
  Args: {
    hideCount?: boolean;
    option: TSelectOption;
  };
  Element: HTMLElement;
}

const FiltersBufferZoneOptionComponent: TOC<FiltersBufferZoneOptionSignature> = <template>
  <StatusOption
    {{! @glint-ignore }}
    @status={{hash color=(categoryColor @option.value) label=(orElse @option.label @option.value)}}
    @hideCount={{orElse @hideCount true}}
    ...attributes
  />
</template>;

export default FiltersBufferZoneOptionComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Filters::BufferZoneOption': typeof FiltersBufferZoneOptionComponent;
    'filters/buffer-zone-option': typeof FiltersBufferZoneOptionComponent;
  }
}
